function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_440",
  "data-name": "Group 440",
  transform: "translate(-335 -879)"
}, React.createElement("circle", {
  id: "Ellipse_32",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(335 879)"
}), React.createElement("circle", {
  id: "Ellipse_32-2",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(373 879)"
}), React.createElement("circle", {
  id: "Ellipse_32-3",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(411 879)"
}), React.createElement("circle", {
  id: "Ellipse_32-4",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(449 879)"
}), React.createElement("circle", {
  id: "Ellipse_32-5",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(487 879)"
}), React.createElement("circle", {
  id: "Ellipse_32-6",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(525 879)"
}), React.createElement("circle", {
  id: "Ellipse_32-7",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(335 917)"
}), React.createElement("circle", {
  id: "Ellipse_32-8",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(373 917)"
}), React.createElement("circle", {
  id: "Ellipse_32-9",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(411 917)"
}), React.createElement("circle", {
  id: "Ellipse_32-10",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(449 917)"
}), React.createElement("circle", {
  id: "Ellipse_32-11",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(487 917)"
}), React.createElement("circle", {
  id: "Ellipse_32-12",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(525 917)"
}), React.createElement("circle", {
  id: "Ellipse_32-13",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(335 955)"
}), React.createElement("circle", {
  id: "Ellipse_32-14",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(373 955)"
}), React.createElement("circle", {
  id: "Ellipse_32-15",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(411 955)"
}), React.createElement("circle", {
  id: "Ellipse_32-16",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(449 955)"
}), React.createElement("circle", {
  id: "Ellipse_32-17",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(487 955)"
}), React.createElement("circle", {
  id: "Ellipse_32-18",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(525 955)"
}), React.createElement("circle", {
  id: "Ellipse_32-19",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(335 993)"
}), React.createElement("circle", {
  id: "Ellipse_32-20",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(373 993)"
}), React.createElement("circle", {
  id: "Ellipse_32-21",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(411 993)"
}), React.createElement("circle", {
  id: "Ellipse_32-22",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(449 993)"
}), React.createElement("circle", {
  id: "Ellipse_32-23",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(487 993)"
}), React.createElement("circle", {
  id: "Ellipse_32-24",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(525 993)"
}), React.createElement("circle", {
  id: "Ellipse_32-25",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(335 1031)"
}), React.createElement("circle", {
  id: "Ellipse_32-26",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(373 1031)"
}), React.createElement("circle", {
  id: "Ellipse_32-27",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(411 1031)"
}), React.createElement("circle", {
  id: "Ellipse_32-28",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(449 1031)"
}), React.createElement("circle", {
  id: "Ellipse_32-29",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(487 1031)"
}), React.createElement("circle", {
  id: "Ellipse_32-30",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(525 1031)"
}), React.createElement("circle", {
  id: "Ellipse_32-31",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(335 1069)"
}), React.createElement("circle", {
  id: "Ellipse_32-32",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(373 1069)"
}), React.createElement("circle", {
  id: "Ellipse_32-33",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(411 1069)"
}), React.createElement("circle", {
  id: "Ellipse_32-34",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(449 1069)"
}), React.createElement("circle", {
  id: "Ellipse_32-35",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(487 1069)"
}), React.createElement("circle", {
  id: "Ellipse_32-36",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(525 1069)"
}), React.createElement("g", {
  id: "Group_428",
  "data-name": "Group 428",
  transform: "translate(-1021.341 -44.619)"
}, React.createElement("path", {
  id: "Path_966",
  "data-name": "Path 966",
  d: "M1380.341,1019.871c13.5,28.158,42.267,49.107,75.581,49.107,32.4,0,60.483-19.907,74.419-46.82-15.182-26.03-43.382-46.539-75.688-46.539C1423.3,975.619,1395.814,995.108,1380.341,1019.871Z",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), React.createElement("ellipse", {
  id: "Ellipse_1195",
  "data-name": "Ellipse 1195",
  cx: 37.736,
  cy: 38.142,
  rx: 37.736,
  ry: 38.142,
  transform: "translate(1417.341 983.619)",
  fill: "#937ef8"
}), React.createElement("circle", {
  id: "Ellipse_1196",
  "data-name": "Ellipse 1196",
  cx: 25,
  cy: 25,
  r: 25,
  transform: "translate(1430.341 996.62)",
  fill: "#5603ad"
}), React.createElement("circle", {
  id: "Ellipse_1197",
  "data-name": "Ellipse 1197",
  cx: 13.5,
  cy: 13.5,
  r: 13.5,
  transform: "translate(1442.341 1008.619)",
  fill: "#ff525f"
})));

var SvgEyeTracking = function SvgEyeTracking(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgEyeTracking, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eye-tracking.e87a3e63.svg";
export { ForwardRef as ReactComponent };